module.exports = __webpack_public_path__ + "img/inst-11.5c35f5d2.png";